export default __webpack_public_path__ + "static/media/sendMessageIcon.cf3db476.svg";